import { v4 as uuidv4 } from "uuid";

import {
  GoogleIntegrationCreateFailure,
  GoogleIntegrationCreateSuccess,
  IntegrationCreateFailure,
  IntegrationCreateSuccess,
  SfIntegrationCreateFailure,
  SfIntegrationCreateSuccess,
  VivaIntegrationCreateFailure,
  VivaIntegrationCreateSuccess,
  WebexIntegrationCreateFailure,
  WebexIntegrationCreateSuccess,
} from "../../../Application/services/realTimeNotification/events/accounts/accountsEvents";
import { type IntegrationTypes } from "../types";
import { WebexConnector } from "./WebexConnector";

export const getWebexConnector = () => {
  return new WebexConnector(true);
};

export const createIntegrationEvents = [
  IntegrationCreateSuccess,
  IntegrationCreateFailure,
  GoogleIntegrationCreateSuccess,
  GoogleIntegrationCreateFailure,
  WebexIntegrationCreateFailure,
  WebexIntegrationCreateSuccess,
  VivaIntegrationCreateSuccess,
  VivaIntegrationCreateFailure,
  SfIntegrationCreateSuccess,
  SfIntegrationCreateFailure,
];

export const generateNotificationId = (type: IntegrationTypes) => `integration_${type}_${uuidv4()}`;
